/*
window.onload = function () {
	const spinner = document.getElementById('loading');
	spinner.classList.add('loaded');
}
*/
// setTimeout(loaderClose,1000);

$(function () {
	var h = $(window).height();
	$('#is-loading ,#loading').height(h).css('display', 'block');
});

$(window).on("load", function () {
	$('#is-loading').delay(900).fadeOut(800);
	$('#loading').delay(600).fadeOut(300);

});


$(function () {
	setTimeout('stopload()', 10000);
});

function stopload() {
	$('#is-loading').delay(900).fadeOut(800);
	$('#loading').delay(600).fadeOut(300);
}
